import { Reservation } from "@omni/types/api/cart/bff/shared/reservation.model";
import { ThunkDispatch } from "redux-thunk";

import createApiModule from "@/redux/create-api-module";
import {
    IState,
    TApiAction,
    TExtraThunkArgs,
    TValueAction
} from "@/redux/store.types";
import { getApiDataState } from "@/redux/utils";
import { Config } from "@/utils/config.utils";

import { $OrderDetailModuleName } from "./orderDetail.types";

const { actions, constants } = createApiModule(
    $OrderDetailModuleName,
    ({ url }) => url
);

export const loadOrderById =
    (orderId: string) =>
    (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) => {
        return dispatch(
            actions.load(
                {
                    path: {
                        url: `/${Config.general.basestore}/orders/${orderId}`,
                        bff: true
                    }
                },
                "GET"
            )
        );
    };

export const load =
    (force: boolean = false) =>
    async (dispatch: ThunkDispatch<IState, TExtraThunkArgs, TApiAction>) =>
        await dispatch(
            actions.load(
                {
                    path: {
                        url: `/${Config.general.basestore}/orders`,
                        bff: true
                    }
                },
                "GET",
                force
            )
        );

// This is to be able to update orderdetails as they could return from other API calls
export const updateOrderDetails =
    (payload: { reservation: Reservation }) =>
    (
        dispatch: ThunkDispatch<IState, TExtraThunkArgs, TValueAction>,
        getState: () => IState
    ) => {
        const orderDetailsState = getApiDataState(
            getState(),
            $OrderDetailModuleName
        );

        if (!orderDetailsState?.data) {
            return;
        }

        return dispatch({
            type: constants.SUCCESS,
            payload: {
                ...orderDetailsState,
                order: { ...orderDetailsState.data?.order, ...payload }
            }
        });
    };

export const clear = actions.clear;
export const refetch = actions.refetch;
export const OrderDetailsConstants = constants;
